/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WsUnsubscribe
 */
export interface WsUnsubscribe {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsUnsubscribe
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WsUnsubscribe
     */
    address: string;
}

/**
 * Check if a given object implements the WsUnsubscribe interface.
 */
export function instanceOfWsUnsubscribe(value: object): value is WsUnsubscribe {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function WsUnsubscribeFromJSON(json: any): WsUnsubscribe {
    return WsUnsubscribeFromJSONTyped(json, false);
}

export function WsUnsubscribeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsUnsubscribe {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'address': json['address'],
    };
}

export function WsUnsubscribeToJSON(json: any): WsUnsubscribe {
    return WsUnsubscribeToJSONTyped(json, false);
}

export function WsUnsubscribeToJSONTyped(value?: WsUnsubscribe | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'address': value['address'],
    };
}

